export const formatTripleSpaced = (nStr) => {
  const remainder = nStr.length % 3;
  return (nStr.substr(0, remainder) + nStr.substr(remainder).replace(/(\d{3})/g, ' $1')).trim();
};
const getIntegerPart = (number) => (number > 0 ? Math.floor(number) : Math.ceil(number));
/** Форматирование дробных чисел в виде строки с разделителями разрядов (пробелы) и [toFixedParam] знаками после запятой */
const formatCommedAndTripleSpaced = (number, toFixedParam = 2) => {
  const subZero = (number || 0) < 0 ? '-' : '';
  const absNumber = Math.abs(number || 0);
  return `${subZero + formatTripleSpaced(getIntegerPart(absNumber || 0).toString())},${(absNumber || 0).toFixed(toFixedParam).slice(-toFixedParam)}`;
};
export const floatRenderer = (value) => (typeof value !== 'number' ? '' : formatCommedAndTripleSpaced(value));
export const thousandsFloatRenderer = (value) => (typeof value !== 'number' ? '' : formatCommedAndTripleSpaced(value, 3));
export const floatMarkRender = (value) => {
  return Number.isNaN(value) ? null : floatRenderer(+value)
}
// 0.99 => 99%
export const percentageRenderer = (value) => `${floatRenderer(value * 100)}%`;

export const arrayStringRenderer = (value) => (value && value.length > 0 ? value.join(', ') : '');

const zeroPad = (num) => (num > 9 ? '' : '0') + num;
export const dateRenderer = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return `${zeroPad(date.getDate())}.${zeroPad(date.getMonth() + 1)}.${date.getFullYear()}`;
};
export function dateTimeRenderer(value) {
  if (!value) return '';
  const date = new Date(value);
  return `${zeroPad(date.getDate())}.${zeroPad(date.getMonth() + 1)}.${date.getFullYear()} ${zeroPad(date.getHours())}:${zeroPad(date.getMinutes())}`;
}

export default {
  floatMarkRender,
  formatTripleSpaced,
  arrayStringRenderer,
  dateRenderer,
  dateTimeRenderer,
  floatRenderer,
  thousandsFloatRenderer,
  percentageRenderer,
};
